










import {Component, Vue, Prop, Model} from "vue-property-decorator";

@Component({})

export default class DeviceRowMobile extends Vue {

  // expand:boolean = true;

  @Model('input', {type:Boolean}) expand!: boolean

  toggleExpansion(){
    this.$emit('input',!this.expand)
  }

}

